import gql from 'graphql-tag';

const contractQueries = {

    deleteBuildings: gql`
        query DeleteContractBuildings($id: [ID!]!) {
            deletecontractbuildings(id: $id) {
                id
            }
        }
    `,
};

export default contractQueries;
